import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-likert',
  templateUrl: './likert.component.html',
  styleUrls: ['./likert.component.scss'],
})
export class LikertComponent implements OnInit {
  @Input('form') form: FormGroup;
  @Input('controlName') controlName: string;

  @Input('rangeLow') rangeLow: number = 1;
  @Input('rangeHigh') rangeHigh: number = 5;
  @Input('labelLow') labelLow: string;
  @Input('labelHigh') labelHigh: string;

  scale: number[];

  constructor() {}

  ngOnInit(): void {
    this.init();
  }

  private init() {
    this.scale = Array.from(
      Array(this.rangeHigh - this.rangeLow + 1).keys()
    ).map((value) => value + this.rangeLow);
  }

  onChange(value) {
    (this.form.controls[`${this.controlName}_Group`] as FormGroup).controls[
      this.controlName
    ].setValue(value);
  }
}
